export const links = [
  {
    type: "personal projects",
    name: "Marketplace web application",
    link: "https://drive.google.com/file/d/1Q2csrfGWO9mWO0SyzeyTJuip154e_8u1/view",
    img: "marketplace_app.PNG",
  },
  {
    type: "personal projects",
    name: "movie reviews backend app",
    link: "https://drive.google.com/file/d/1zx2pIb7exHbeeWlnF9-Z0ik2Y-hL80gU/view",
    img: "movie_reviews.PNG",
  },
  {
    type: "personal projects",
    name: "Simple E-commerce Web App",
    link: "https://simple-ecommerce-web-app.netlify.app/",
    img: "simple-web-app.PNG",
  },
  {
    type: "personal projects",
    name: "Blog Web App",
    link: "https://my-blog-web-app.netlify.app/",
    img: "my-blog-app.PNG",
  },
  {
    type: "personal projects",
    name: "Support Ticket System",
    link: "https://github.com/cgomez374/support-ticketing-system",
    img: "support-ticket-system.PNG",
  },
];
